import React from 'react';
import { useSiteInfo } from '@contexts/SiteInfoContext';
import ServerPath from '../../configs/serverPath';
import FootText from '../Footer/FooterText';

const BrowserUpgradePage = () => {
    const { composePath, siteName, preferredSiteName } = useSiteInfo();
    return (
        <div className="app">
            <div className="header">
                <div className="header__logo" />
            </div>
            <div className="main">
                <div className="browser-upgrade">
                    <div className="browser-upgrade__title">
                        Browser Upgrade Needed
                    </div>
                    <div className="browser-upgrade__download">
                        <div className="browser-upgrade__item">
                            <img
                                className="browser-upgrade__img"
                                src={composePath({
                                    pathType: ServerPath.globalImage,
                                    pathName: 'browser_Firefox-L.png',
                                })}
                                alt="Download Firefox"
                            />
                            <a
                                className="browser-upgrade__btn"
                                href="https://support.mozilla.org/kb/update-firefox-latest-version"
                            >
                                <i className="icon icon-download" />
                                <span className="browser-upgrade__text">FireFox</span>
                            </a>
                        </div>
                        <div className="browser-upgrade__item">
                            <img
                                className="browser-upgrade__img"
                                src={composePath({
                                    pathType: ServerPath.globalImage,
                                    pathName: 'browser_chrome-L.png',
                                })}
                                alt="Download Chrome"
                            />
                            <a
                                className="browser-upgrade__btn"
                                href="https://www.google.com/chrome/browser/desktop/"
                            >
                                <i className="icon icon-download" />
                                <span className="browser-upgrade__text">Chrome</span>
                            </a>
                        </div>
                        <div className="browser-upgrade__item">
                            <img
                                className="browser-upgrade__img"
                                src={composePath({
                                    pathType: ServerPath.globalImage,
                                    pathName: 'browser_edge-L.png',
                                })}
                                alt="Download Edge"
                            />
                            <a className="browser-upgrade__btn" href="https://www.microsoft.com/zh-tw/edge">
                                <i className="icon icon-download" />
                                <span className="browser-upgrade__text">Edge</span>
                            </a>
                        </div>

                    </div>
                    <p className="text">To facilitate your betting experience, please upgrade to the latest browser.</p>
                    <p className="text">为优化您的浏览体验，建议您更换以上浏览器并更新至最新版本。</p>
                </div>
            </div>
            <div className="footer">
                <FootText siteName={preferredSiteName || siteName} />
            </div>
        </div>
    );
};

export default BrowserUpgradePage;
